import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _checkReservationDetailsRequest = { date: 'google.protobuf.Timestamp' };
var _checkReservationDetailsResponse = {};
var _checkTimeSlotRequest = { date: 'google.protobuf.Timestamp' };
var _checkTimeSlotResponse = {};
var _getScheduledTimeSlotsRequest = { timeRange: '_timeRange' };
var _getScheduledTimeSlotsResponse = { timeSlots: '_timeSlot' };
var _getTimeSlotsRequest = { date: 'google.protobuf.Timestamp' };
var _getTimeSlotsResponse = { timeSlots: '_timeSlot' };
var _timeRange = {
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
};
var _timeSlot = { startDate: 'google.protobuf.Timestamp' };
function resolveWixTableReservationsTimeSlotV1TimeSlotsServiceUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/table-reservations/reservations',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/table-reservations/reservations',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/table-reservations/reservations',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/table-reservations/reservations',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/table-reservations/reservations',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/table-reservations/reservations',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/table-reservations/reservations',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/table-reservations/reservations',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/table-reservations/reservations',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/table-reservations/reservations',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/table-reservations/reservations',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/table-reservations/reservations',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/table-reservations/reservations',
                destPath: '',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/table-reservations/reservations',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/table-reservations/reservations',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Returns a list of time slots at a specified reservation location on a specified `date`, and their availability for a specified `partySize`.
 *
 * Without passing optional parameters, the list will contain a single time slot at the specified `date`.
 * Use `slotsBefore` and `slotsAfter` to get additional time slots before and after the specified `date`.
 *
 * If you do not provide a `duration`, the duration will be calculated automatically based on the reservation location's configuration.
 * The reservation location's settings used to determine the duration are its `defaultTurnoverTime` and `turnoverTimeRules`. These specify how much time should be allotted for a reservation of a party of a specified size.
 *
 * The interval between `startDate`s of time slots in the response is determined by the reservation location's `timeSlotInterval`. This interval is not affected by the `duration` provided.
 */
export function getTimeSlots(payload) {
    var _a = serializer(_getTimeSlotsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTimeSlotsResponse, {
        _timeSlot: _timeSlot,
    }).fromJSON;
    function __getTimeSlots(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.table_reservations.v1.time_slot',
            method: 'POST',
            methodFqn: 'wix.table_reservations.time_slot.v1.TimeSlotsService.GetTimeSlots',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixTableReservationsTimeSlotV1TimeSlotsServiceUrl({
                protoPath: '/v1/time-slots',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTimeSlots.fromReq = fromReq;
    __getTimeSlots.__isAmbassador = true;
    return __getTimeSlots;
}
/** Check reservation details. */
export function checkReservationDetails(payload) {
    var _a = serializer(_checkReservationDetailsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_checkReservationDetailsResponse, {}).fromJSON;
    function __checkReservationDetails(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.table_reservations.v1.time_slot',
            method: 'POST',
            methodFqn: 'wix.table_reservations.time_slot.v1.TimeSlotsService.CheckReservationDetails',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixTableReservationsTimeSlotV1TimeSlotsServiceUrl({
                protoPath: '/v1/check-reservation-details',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __checkReservationDetails.fromReq = fromReq;
    __checkReservationDetails.__isAmbassador = true;
    return __checkReservationDetails;
}
/**
 * Checks a restaurant's availability to accommodate a reservation for a specified party size in a specified time slot.
 *
 * This endpoint returns availability information for the restaurant's table combinations, and flags any party pacing or seat pacing conflicts that the proposed reservation would cause.
 */
export function checkTimeSlot(payload) {
    var _a = serializer(_checkTimeSlotRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_checkTimeSlotResponse, {}).fromJSON;
    function __checkTimeSlot(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.table_reservations.v1.time_slot',
            method: 'POST',
            methodFqn: 'wix.table_reservations.time_slot.v1.TimeSlotsService.CheckTimeSlot',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixTableReservationsTimeSlotV1TimeSlotsServiceUrl({
                protoPath: '/v1/check-time-slot',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __checkTimeSlot.fromReq = fromReq;
    __checkTimeSlot.__isAmbassador = true;
    return __checkTimeSlot;
}
/**
 * Returns a list of scheduled time slots at a specified reservation location for a specified time range, and their availability for a specified `partySize`.
 *
 * Scheduled time slots are sequential time periods whose start times fall within a restaurant's opening hours. Opening hours are defined in the reservation location's `businessSchedule`.
 *
 * [Experiences](https://dev.wix.com/docs/api-reference/business-solutions/restaurants/wix-restaurants-new/reservations/experiences/introduction) have their own business schedules that override that of the reservation location. To get scheduled time slots for an experience, pass the ID of that experience to this method.
 *
 * If a restaurant is open during distinct time periods throughout the week, the `startDate` of the first scheduled time slot returned for each period is the same as starting time of that time period.
 * If a restaurant is always open, the `startDate` of the first returned scheduled time slot for each week is Sunday at `00:00`.
 *
 * The duration of scheduled time slots and the interval between their `startDate`s is determined by the reservation location's `timeSlotInterval`.
 *
 * For example:
 *
 * A restaurant is open every night from `22:30` to `03:55` with a `timeSlotInterval` of 1 hour.
 * If you called this method with the time range `23:00` to `02:50`, it would return time slots starting at `23:30`, `00:30`, `01:30`, and `02:30`.
 */
export function getScheduledTimeSlots(payload) {
    var _a = serializer(_getScheduledTimeSlotsRequest, { _timeRange: _timeRange }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getScheduledTimeSlotsResponse, {
        _timeSlot: _timeSlot,
    }).fromJSON;
    function __getScheduledTimeSlots(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.table_reservations.v1.time_slot',
            method: 'POST',
            methodFqn: 'wix.table_reservations.time_slot.v1.TimeSlotsService.GetScheduledTimeSlots',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixTableReservationsTimeSlotV1TimeSlotsServiceUrl({
                protoPath: '/v1/scheduled-time-slots',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getScheduledTimeSlots.fromReq = fromReq;
    __getScheduledTimeSlots.__isAmbassador = true;
    return __getScheduledTimeSlots;
}
//# sourceMappingURL=http.impl.js.map